import { AddAPhoto } from "@mui/icons-material";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { ENDPOINTS } from "config/constants";
import { useFetch } from "hooks";
import useTranslation from "hooks/useTranslation";
import { useSnackbar } from "notistack";
import { useCallback } from "react";
import { CameraModel } from "types";

interface IUploadPolygons {
  cameraId?: number | string;
  onReload?: (args?: any) => any;
}

const FRAME_TIMEOUT_MS = 60000;

const GetFrame = ({ cameraId, onReload }: IUploadPolygons) => {
  const { isLoading, callFetch: callFetchGet } = useFetch<{
    camera?: CameraModel;
  }>("GET");
  const { enqueueSnackbar } = useSnackbar();
  const t = useTranslation();

  const onUpload = useCallback(() => {
    if (!cameraId) return;
    callFetchGet(ENDPOINTS.getFrame + cameraId, { timeout: FRAME_TIMEOUT_MS })
      .then((res) => {
        enqueueSnackbar(res.message || t["Camera frame updated"] || "Camera frame updated", {
          variant: "success"
        });
        onReload?.();
      })
      .catch((err) => {
        enqueueSnackbar(err?.message || t["Could not fetch frame"] || "Could not fetch frame", {
          variant: "error"
        });
      });
  }, [callFetchGet, onReload, cameraId, enqueueSnackbar, t]);

  return isLoading ? (
    <IconButton>
      <CircularProgress />
    </IconButton>
  ) : (
    <Tooltip title={t["Get camera frame"]}>
      <IconButton onClick={onUpload}>
        <AddAPhoto />
      </IconButton>
    </Tooltip>
  );
};

export default GetFrame;
